import { render, staticRenderFns } from "./infoclient.vue?vue&type=template&id=1a4ffdb8&scoped=true"
import script from "./infoclient.vue?vue&type=script&lang=js"
export * from "./infoclient.vue?vue&type=script&lang=js"
import style0 from "./infoclient.vue?vue&type=style&index=0&id=1a4ffdb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4ffdb8",
  null
  
)

export default component.exports